import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {EmotoradEventTypes} from "./Events";

export enum EmotoradEventContainerTypes {
    Journeys = "f1d269d7-5856-45cf-bfd6-6c5483f1b6f0",
}

export const emotoradEventContainerTypeByEventType: Record<EmotoradEventTypes, EmotoradEventContainerTypes> = {
    [EmotoradEventTypes.call]: EmotoradEventContainerTypes.Journeys,
    [EmotoradEventTypes.lead]: EmotoradEventContainerTypes.Journeys,
    [EmotoradEventTypes.walkin]: EmotoradEventContainerTypes.Journeys,
    [EmotoradEventTypes.testride]: EmotoradEventContainerTypes.Journeys,
    [EmotoradEventTypes.sales]: EmotoradEventContainerTypes.Journeys,
    [EmotoradEventTypes.dispositionTracker]: EmotoradEventContainerTypes.Journeys,
};

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const EMOTORAD__EVENT_CONTAINER__LIFECYCLE_OVERVIEWS__DISPOSITION__COLUMN_ID = "388f21d0-8cbd-41a6-a59b-129356b02755" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__LIFECYCLE_OVERVIEWS__ORGANIZATIONAL_UNIT__COLUMN_ID = "c13141e0-9ddd-43a3-a157-3d93b643fd0c" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__L2_DISPOSITION__COLUMN_ID = "a3fd9469-8dde-4569-a7f1-b9e2f4adf4a5" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__L3_DISPOSITION__COLUMN_ID = "2bf9e23d-7f3c-49e4-b79d-9478f4f6db12" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID = "727b5b6c-145d-515b-8205-935cae4c9b63" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CUSTOMER__COLUMN_ID = "7c94b028-f3e4-4725-9ed9-baf78a2accea" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID = "c98bb617-7989-5e64-9e03-834e9953d800" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__STATUS__COLUMN_ID = "8b1dcd2d-f116-56c4-835f-9867430eece4" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID = "54e1f302-03d7-53dd-a95e-905c13b32e65" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID = "f2b4f502-0a6b-5543-a04c-6cd376237676" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID = "28194324-12c4-5a1d-a3a9-ba42dca2a6fb" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID = "96be8390-215d-5b85-9732-4fd653fb44de" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__REMARKS_RECENT__COLUMN_ID = "48fc687a-2dcc-52b6-a37f-ef0be2954206" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID = "3989fa8d-479b-5dad-95cb-18dc303b178d" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__ASSIGNED_ON__COLUMN_ID = "525b9c93-10b3-54eb-bfc6-be9e7e1462c3" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID = "02b2e6c1-efe0-5e8b-9404-722c5f4d9e7d" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID = "33a067e0-6013-56fb-af65-2a9308c2dcee" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID = "a908bba2-f6db-5c5b-8243-277ad92e872e" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID = "5b394b38-9eb4-5dc9-b5ce-bbe7a82110e7" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__UTM_TERM__COLUMN_ID = "a74deb9d-4e72-5556-a210-5fa9701c0174" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID = "8b8f4cd3-541b-54f7-8864-4871df6e1fb2" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__FBCLID__COLUMN_ID = "6b6e526d-f358-510c-890c-3b6becc8896e" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__GCLID__COLUMN_ID = "044a4c02-3a29-5b0b-9aba-0f825126ec10" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CUSTOMER_PINCODE__COLUMN_ID = "fa2f1d27-de32-46d3-8662-746df628982c" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__MODEL_VARIANT__COLUMN_ID = "a92979cc-7b71-4e2e-a56b-14537a0aef39" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__MODEL__COLUMN_ID = "2355f0ac-8ed9-42b3-b618-4f7b4dbde6ce" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__ACTION_PLATFORM__COLUMN_ID = "33e9b385-ec7c-4525-b87c-56effd8235e1" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CUSTOMER_PLATFORM__COLUMN_ID = "997d310d-e445-4932-8fd6-f5baaae824a0" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CATEGORY__COLUMN_ID = "3fd5cd75-da39-4cb2-b003-86fed9592f88" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__ASSIGNED_DEALER_NAME__COLUMN_ID = "df695d90-cd23-451d-bd2e-19c27af2a337" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__PURCHASE_TIMELINE__COLUMN_ID = "43f6c7cf-8917-463f-9e1c-1b5f20686715" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__SOURCE_CHANNEL__COLUMN_ID = "ae8c31cc-4990-4a33-a3d4-05df4900d66b" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CUSTOMER_STATE__COLUMN_ID = "17b1f5e4-f7ce-421f-bb48-d4247d75f244" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CUSTOMER_CITY__COLUMN_ID = "aacf0a6c-919d-4456-8cc4-6944b2f0f5b0" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CUSTOMER_ZONE__COLUMN_ID = "06fd4cf5-cc56-4d4e-ba7b-eb49d49c4063" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__DEALER_PINCODE__COLUMN_ID = "9971e088-3136-4338-91fb-8097b835f5ad" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__DEALER_CITY__COLUMN_ID = "610571cb-a466-401c-9659-13d862abe429" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__DEALER_STATE__COLUMN_ID = "32e74503-cada-4a98-b612-d04b0536300e" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__DEALER_ZONE__COLUMN_ID = "b91d2493-8a96-4ddc-bbee-3ca0cf740c1f" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__WALKINS_COUNT__COLUMN_ID = "1a55ccf3-d0f0-4f49-9857-d8cbb5aae250" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__TEST_RIDES_COUNT__COLUMN_ID = "8dda1326-4784-41e0-95b2-71d595d8aa7e" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__SALES_COUNT__COLUMN_ID = "82f8cc2b-cf0b-4f15-80e8-bb511837ee01" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__LIFE_CYCLE_COUNT__COLUMN_ID = "fbbce7fb-3e1a-4574-b5f3-9d609b5750e0" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__LAST_ACTIVITY_AGE__COLUMN_ID = "72a9211b-274f-40f1-a487-e1dd1ec3113b" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__KAM_NAME__COLUMN_ID = "e003d276-662a-44f1-ac84-39ae293edd04" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__ZSM_NAME__COLUMN_ID = "9401bbda-1062-43ce-8b58-8fa151c6cdfc" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__ASSIGNED_DEALER_CONTACT__COLUMN_ID = "3c3fa5dc-78b9-4944-852e-ce1990966bf0" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__ASSIGNED_DEALER_EMAIL__COLUMN_ID = "1d06f2a6-e32f-4719-bb22-7059d84e6b08" as Uuid;

export const EMOTORAD__EVENT_CONTAINER__CREATED_BY_ROLE__COLUMN_ID = "c4d8e1f2-3a4b-4789-b012-3456789abcde" as Uuid;

export enum EmotoradGenderEnum {
    MALE = "3fec1767-04a7-512e-b51d-2253aa67ff46",
    FEMALE = "79f5c829-9918-5088-a8e3-a2c3bda07186",
    OTHER = "dfa2994d-7198-5e92-b965-89539b598db7",
}

export enum EmotoradYesNoEnum {
    YES = "65324c92-acef-49cf-ab91-ad6fcef8b3a6",
    NO = "3814abbb-fc0f-4c85-8012-c5970049d226",
}

export enum EmotoradCategoryEnum {
    ONLINE = "261cb6bd-8722-4db9-8365-f6381e303b0c",
    CSV = "a7e4ea6b-0882-4d32-94b0-75766d87a3a2",
    AGGREGATOR = "53d588c7-1db2-464f-9b3d-5d0480a53cf0",
}

export enum EmotoradPurchaseTimelineEnum {
    IN_NEXT_10_DAYS = "5a0dd002-994f-4832-8293-208f4e281c71",
    IN_NEXT_10_TO_30_DAYS = "30b5c513-01a8-4bbd-86d0-580af3a0bd42",
    AFTER_A_MONTH = "d2d610e4-0e4c-4134-8673-f3fba1ad3362",
}

export enum EmotoradSourceChannelEnum {
    BILLBOARDS = "9117a4e6-a51a-49ec-9493-70fe25ce56cc",
    REFERRALS = "7786d075-d8f8-4eef-9061-19eeee85a9d7",
    SOCIAL = "2b1fbc79-98ef-4887-8b82-c87753f95074",
    WEBSITE = "056595d6-a1d6-4614-a242-3c7ddaf162ef",
    AGGREGATORS = "f7ed7cf0-b4e2-49b6-964e-7705ec5fedd8",
    PRINT = "02f4ff82-fda9-4c03-af21-3efadece606c",
    TV = "c5dfbcf8-1782-45f9-8105-fec0ae09bfa1",
    DIGITAL = "0cd7548b-7faa-4987-a9a1-3f50ece58150",
    BTL = "05888e38-0e85-43d3-80de-8f02ee406064",
    WALK = "ec14074f-7ed8-494a-9422-80c35170873f",
    TELEPHONIC = "b33f94bc-4b2c-4f81-b599-4a59b1b20ee1",
}

export enum EmotoradCurrentPlatformEnum {
    TESTRIDE_WEBPAGE = "cd9dff49-3bcb-4c07-80e6-7d71de0c095c",
    OTTOPILOT = "5e57860a-9d24-476b-a8a2-47bc39f3023f",
    DIFFERENT_AGGREGATORS = "3eca936f-36ce-4050-8fef-043ab831cf38",
}

export enum EmotoradPrimaryRidingPurposeEnum {
    LIFESTYLE = "3cf8110e-99d0-42e9-8c1b-d4c327ebd16c",
    COMMUTE = "46ee3d72-a2aa-49c3-bdb9-d14f1965b7ef",
    REGULAR_USE = "4b170655-197c-433b-8e50-3e1dc7ed5c27",
}

export enum EmotoradExploringForEnum {
    SELF = "9abd7a52-71c6-4725-b150-98aab86c9080",
    CHILD = "02db3854-d95a-4f8b-b400-1bb3e15d7e98",
}

export enum EmotoradExpectedRidingFrequencyEnum {
    DAILY = "c15c6f64-35df-4249-9eee-0787c6824882",
    ONCE_A_WEEK = "e8f0125c-18ec-4b23-a415-a7c2bd3b4a76",
    TWICE_A_WEEK = "03a584cc-5df3-4977-9915-a28f37566123",
}

export enum EmotoradHeightOfRiderEnum {
    UNDER_150_CM = "f6515d6f-c254-47a3-8f8c-1ea003a4315e",
    CM_150_160 = "367bdb52-50e1-414d-90ea-59f4e835907d",
    CM_160_170 = "e88f7db4-2f30-41aa-8a04-0c69437612b7",
    CM_170_180 = "be3054c7-022b-40bc-b8f2-84bd4e81e963",
    OVER_180_CM = "6477a89e-0995-4a6f-a205-402a2986fc8c",
}

export enum EmotoradOtherBrandConsideredEnum {
    HERO_LECTRO = "5892d3f2-a8c4-443a-96a2-94f4702076f0",
    NINETY_ONE_CYCLES = "e53e0917-cfac-42f0-9651-e575a0673b79",
    FIREFOX = "b146cf9f-9169-4372-951b-f3d160f1d3c5",
    GIANT = "06067ca1-d859-4641-866c-117dc7921b7a",
    TREK = "e8ffb8ff-b317-4cbe-b3e8-ab744efabf75",
    DECATHLON = "52151ed3-ae1f-4e06-b38d-4c8dc78c0300",
    MOTOVOLT = "6277f3ec-aaf3-4604-b02f-8f93b9036ee5",
}

export enum EmotoradEventContainerDispositionEnum {
    NEW_LEAD,
    NOT_CONNECTED_INVALID_NUMBER_NUMBER_UNREACHABLE,
    NOT_CONNECTED_DND_REGISTERED_NUMBER_UNREACHABLE,
    NOT_CONNECTED_NO_ANSWER,
    NOT_CONNECTED_DISCONNECTED,
    NOT_CONNECTED_BUSY_LINE,
    NOT_CONNECTED_SWITCHED_OFF,
    CONNECTED_LOST_BUDGET_ISSUES,
    CONNECTED_LOST_OTHER_BRAND,
    CONNECTED_LOST_JUST_EXPLORING,
    CONNECTED_LOST_OTHERS,
    CONNECTED_HIGH_INTENT_FOLLOW_UP,
    CONNECTED_HIGH_INTENT_ACTION_INITIATED,
    CONNECTED_FUTURE_INTENT,
    CONNECTED_INVALID_TEST_ENTRY,
    CONNECTED_INVALID_SPAM,
    CONNECTED_INVALID_FILLED_BY_MISTAKE,
    CONNECTED_INVALID_DID_NOT_FILLED,
    CONNECTED_INVALID_OTHERS,
    INTERESTED_CALL_BACK_LATER,
    INTERESTED_FUTURE_INTENT,
    INTERESTED_HIGH_INTEREST_FOLLOW_UP,
    INTERESTED_HIGH_INTEREST_ACTION_INITIATED,
    NOT_INTERESTED_PRICE_ISSUES,
    NOT_INTERESTED_COMPETETION,
    NOT_INTERESTED_NOT_SATISFIED,
    NOT_INTERESTED_JUST_EXPLORING,
    NOT_INTERESTED_NO_SHOW,
    NOT_INTERESTED_OTHERS,
}

export const EMOTORAD__EVENT_CONTAINERS__SCOPE_FILTER__ASSIGNED_TO_ME__OPTION_ID = "a4b8c2d1-6e3f-4a5b-9c8d-1e2f3a4b5c6d" as Uuid;

export const EMOTORAD__EVENT_CONTAINERS__SCOPE_FILTER__CREATED_BY_ME__OPTION_ID = "b5c9d3e2-7f40-4b6c-ad9e-2f3a4b5c6d7e" as Uuid;

export enum EmotoradEnquiryDigitalLeadStatusEnum {
    NEW = "96fbd204-45d9-5216-8fef-3b6d4c180ad7",
    DUPLICATE = "81ca0519-4ab0-58db-8686-d0fdd143cf9c",
    RETURN = "f1a5ce59-7596-520f-b7fa-b540bc137876",
}

export enum EmotoradEnquiryDispositionEnum {
    OPEN = "00a7a726-7a2c-5970-a2b0-8c79bc6baede",
}

export type EmotoradDynamicEventContainerSelectField =
    | "exploringFor"
    | "ridingPurpose"
    | "ridingFrequency"
    | "riderHeight"
    | "isFirstCycle"
    | "otherBrand"
    | "purchaseTimeline"
    | "sourceChannel"
    | "category"
    | "currentPlatform";

/** Product rule: implementation notes, schedule-next-call trigger, optional free-text on remarks. */
export type EmotoradEventContainerDispositionRule = {
    implementationNote: string;
    requiresScheduleNextCall: boolean;
    requiresFreeTextRemarks: boolean;
};

export const emotoradGenders: Record<EmotoradGenderEnum, {id: Uuid; displayName: string}> = {
    [EmotoradGenderEnum.MALE]: {
        id: EmotoradGenderEnum.MALE as Uuid,
        displayName: "Male",
    },
    [EmotoradGenderEnum.FEMALE]: {
        id: EmotoradGenderEnum.FEMALE as Uuid,
        displayName: "Female",
    },
    [EmotoradGenderEnum.OTHER]: {
        id: EmotoradGenderEnum.OTHER as Uuid,
        displayName: "Other",
    },
};

/** Shared Yes / No option ids (first cycle, follow-up required, test ride taken). */
export const emotoradYesNoOptions: Record<EmotoradYesNoEnum, {id: Uuid; displayName: string}> = {
    [EmotoradYesNoEnum.YES]: {
        id: EmotoradYesNoEnum.YES as Uuid,
        displayName: "Yes",
    },
    [EmotoradYesNoEnum.NO]: {
        id: EmotoradYesNoEnum.NO as Uuid,
        displayName: "No",
    },
};

export const getEmotoradYesNoSelectOptions = () => Object.values(emotoradYesNoOptions);

/** Purchase timeline — shared across journey and events. */
export const emotoradPurchaseTimelines: Record<EmotoradPurchaseTimelineEnum, {id: Uuid; displayName: string}> = {
    [EmotoradPurchaseTimelineEnum.IN_NEXT_10_DAYS]: {
        id: EmotoradPurchaseTimelineEnum.IN_NEXT_10_DAYS as Uuid,
        displayName: "In next 10 days",
    },
    [EmotoradPurchaseTimelineEnum.IN_NEXT_10_TO_30_DAYS]: {
        id: EmotoradPurchaseTimelineEnum.IN_NEXT_10_TO_30_DAYS as Uuid,
        displayName: "In next 10-30 days",
    },
    [EmotoradPurchaseTimelineEnum.AFTER_A_MONTH]: {
        id: EmotoradPurchaseTimelineEnum.AFTER_A_MONTH as Uuid,
        displayName: "After a month",
    },
};

export const getEmotoradPurchaseTimelineSelectOptions = () => Object.values(emotoradPurchaseTimelines);

/** Source channel — journey, lead event, sales event. */
export const emotoradSourceChannels: Record<EmotoradSourceChannelEnum, {id: Uuid; displayName: string}> = {
    [EmotoradSourceChannelEnum.BILLBOARDS]: {
        id: EmotoradSourceChannelEnum.BILLBOARDS as Uuid,
        displayName: "Billboards",
    },
    [EmotoradSourceChannelEnum.REFERRALS]: {
        id: EmotoradSourceChannelEnum.REFERRALS as Uuid,
        displayName: "Referrals",
    },
    [EmotoradSourceChannelEnum.SOCIAL]: {
        id: EmotoradSourceChannelEnum.SOCIAL as Uuid,
        displayName: "Social",
    },
    [EmotoradSourceChannelEnum.WEBSITE]: {
        id: EmotoradSourceChannelEnum.WEBSITE as Uuid,
        displayName: "Website",
    },
    [EmotoradSourceChannelEnum.AGGREGATORS]: {
        id: EmotoradSourceChannelEnum.AGGREGATORS as Uuid,
        displayName: "Aggregators",
    },
    [EmotoradSourceChannelEnum.PRINT]: {
        id: EmotoradSourceChannelEnum.PRINT as Uuid,
        displayName: "Print",
    },
    [EmotoradSourceChannelEnum.TV]: {
        id: EmotoradSourceChannelEnum.TV as Uuid,
        displayName: "TV",
    },
    [EmotoradSourceChannelEnum.DIGITAL]: {
        id: EmotoradSourceChannelEnum.DIGITAL as Uuid,
        displayName: "Digital",
    },
    [EmotoradSourceChannelEnum.BTL]: {
        id: EmotoradSourceChannelEnum.BTL as Uuid,
        displayName: "BTL",
    },
    [EmotoradSourceChannelEnum.WALK]: {
        id: EmotoradSourceChannelEnum.WALK as Uuid,
        displayName: "Walk",
    },
    [EmotoradSourceChannelEnum.TELEPHONIC]: {
        id: EmotoradSourceChannelEnum.TELEPHONIC as Uuid,
        displayName: "Telephonic",
    },
};

export const getEmotoradSourceChannelSelectOptions = () => Object.values(emotoradSourceChannels);

/** Current platform — journey and lead/call/walk-in/test-ride events. */
export const emotoradCurrentPlatforms: Record<EmotoradCurrentPlatformEnum, {id: Uuid; displayName: string}> = {
    [EmotoradCurrentPlatformEnum.TESTRIDE_WEBPAGE]: {
        id: EmotoradCurrentPlatformEnum.TESTRIDE_WEBPAGE as Uuid,
        displayName: "Testride-webpage",
    },
    [EmotoradCurrentPlatformEnum.OTTOPILOT]: {
        id: EmotoradCurrentPlatformEnum.OTTOPILOT as Uuid,
        displayName: "Ottopilot",
    },
    [EmotoradCurrentPlatformEnum.DIFFERENT_AGGREGATORS]: {
        id: EmotoradCurrentPlatformEnum.DIFFERENT_AGGREGATORS as Uuid,
        displayName: "Different Aggregators",
    },
};

export const getEmotoradCurrentPlatformSelectOptions = () => Object.values(emotoradCurrentPlatforms);

/** Primary riding purpose — lead, call, walk-in, test ride. */
export const emotoradPrimaryRidingPurposes: Record<EmotoradPrimaryRidingPurposeEnum, {id: Uuid; displayName: string}> = {
    [EmotoradPrimaryRidingPurposeEnum.LIFESTYLE]: {
        id: EmotoradPrimaryRidingPurposeEnum.LIFESTYLE as Uuid,
        displayName: "Lifestyle",
    },
    [EmotoradPrimaryRidingPurposeEnum.COMMUTE]: {
        id: EmotoradPrimaryRidingPurposeEnum.COMMUTE as Uuid,
        displayName: "Commute",
    },
    [EmotoradPrimaryRidingPurposeEnum.REGULAR_USE]: {
        id: EmotoradPrimaryRidingPurposeEnum.REGULAR_USE as Uuid,
        displayName: "Regular use",
    },
};

export const getEmotoradPrimaryRidingPurposeSelectOptions = () => Object.values(emotoradPrimaryRidingPurposes);

/** Exploring for — lead, call, walk-in, test ride. */
export const emotoradExploringForOptions: Record<EmotoradExploringForEnum, {id: Uuid; displayName: string}> = {
    [EmotoradExploringForEnum.SELF]: {
        id: EmotoradExploringForEnum.SELF as Uuid,
        displayName: "Self",
    },
    [EmotoradExploringForEnum.CHILD]: {
        id: EmotoradExploringForEnum.CHILD as Uuid,
        displayName: "Child",
    },
};

export const getEmotoradExploringForSelectOptions = () => Object.values(emotoradExploringForOptions);

/** Height of rider — lead, call, walk-in, test ride. */
export const emotoradHeightOfRiderOptions: Record<EmotoradHeightOfRiderEnum, {id: Uuid; displayName: string}> = {
    [EmotoradHeightOfRiderEnum.UNDER_150_CM]: {
        id: EmotoradHeightOfRiderEnum.UNDER_150_CM as Uuid,
        displayName: "<150 cm",
    },
    [EmotoradHeightOfRiderEnum.CM_150_160]: {
        id: EmotoradHeightOfRiderEnum.CM_150_160 as Uuid,
        displayName: "150-160 cm",
    },
    [EmotoradHeightOfRiderEnum.CM_160_170]: {
        id: EmotoradHeightOfRiderEnum.CM_160_170 as Uuid,
        displayName: "160-170 cm",
    },
    [EmotoradHeightOfRiderEnum.CM_170_180]: {
        id: EmotoradHeightOfRiderEnum.CM_170_180 as Uuid,
        displayName: "170-180 cm",
    },
    [EmotoradHeightOfRiderEnum.OVER_180_CM]: {
        id: EmotoradHeightOfRiderEnum.OVER_180_CM as Uuid,
        displayName: ">180 cm",
    },
};

export const getEmotoradHeightOfRiderSelectOptions = () => Object.values(emotoradHeightOfRiderOptions);

/** Other brands considered — lead event only. */
export const emotoradOtherBrandsConsidered: Record<EmotoradOtherBrandConsideredEnum, {id: Uuid; displayName: string}> = {
    [EmotoradOtherBrandConsideredEnum.HERO_LECTRO]: {
        id: EmotoradOtherBrandConsideredEnum.HERO_LECTRO as Uuid,
        displayName: "Hero Lectro",
    },
    [EmotoradOtherBrandConsideredEnum.NINETY_ONE_CYCLES]: {
        id: EmotoradOtherBrandConsideredEnum.NINETY_ONE_CYCLES as Uuid,
        displayName: "Ninety one cycles",
    },
    [EmotoradOtherBrandConsideredEnum.FIREFOX]: {
        id: EmotoradOtherBrandConsideredEnum.FIREFOX as Uuid,
        displayName: "Firefox",
    },
    [EmotoradOtherBrandConsideredEnum.GIANT]: {
        id: EmotoradOtherBrandConsideredEnum.GIANT as Uuid,
        displayName: "Giant",
    },
    [EmotoradOtherBrandConsideredEnum.TREK]: {
        id: EmotoradOtherBrandConsideredEnum.TREK as Uuid,
        displayName: "Trek",
    },
    [EmotoradOtherBrandConsideredEnum.DECATHLON]: {
        id: EmotoradOtherBrandConsideredEnum.DECATHLON as Uuid,
        displayName: "Decathalon",
    },
    [EmotoradOtherBrandConsideredEnum.MOTOVOLT]: {
        id: EmotoradOtherBrandConsideredEnum.MOTOVOLT as Uuid,
        displayName: "Motovolt",
    },
};

export const getEmotoradOtherBrandsConsideredSelectOptions = () => Object.values(emotoradOtherBrandsConsidered);

/** Workspace lifecycle — must match backend `WorkspaceStatus` / other workspaces (Bobcard, Dulux, Dhiraagu). */
/**
 * Journey dispositions — L1/L2/L3 hierarchy is encoded in `flatDisposition` as underscore-separated
 * segments (hyphens inside a segment), same as Dulux/Bobcard. The UI splits on `_` for cascading selects.
 * Per-leaf behaviour: {@link EMOTORAD_EVENT_CONTAINER_DISPOSITION_RULES}.
 */
export const emotoradEventContainerDispositions: Record<
    EmotoradEventContainerDispositionEnum,
    {
        id: Uuid;
        displayName: string;
        flatDisposition: string;
    }
> = {
    [EmotoradEventContainerDispositionEnum.NEW_LEAD]: {
        id: "01e10ff3-39e3-5320-86ab-6c04415b52d8" as Uuid,
        displayName: "New Lead",
        flatDisposition: "new-lead",
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_INVALID_NUMBER_NUMBER_UNREACHABLE]: {
        id: "66ca0a17-74b7-5fcc-b089-28edf485bb8b" as Uuid,
        displayName: "Not Connected Invalid Number Number unreachable",
        flatDisposition: "not-connected_invalid-number_number-unreachable",
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_DND_REGISTERED_NUMBER_UNREACHABLE]: {
        id: "bc727ba9-8ee7-5396-be8e-2241a8c5becb" as Uuid,
        displayName: "Not Connected DND Registered Number unreachable",
        flatDisposition: "not-connected_dnd-registered_number-unreachable",
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_NO_ANSWER]: {
        id: "48c73588-b181-5e66-a6ac-77d4b7e50b32" as Uuid,
        displayName: "Not Connected No Answer",
        flatDisposition: "not-connected_no-answer",
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_DISCONNECTED]: {
        id: "80aa7472-e485-5ee0-89e9-572495db80d6" as Uuid,
        displayName: "Not Connected Disconnected",
        flatDisposition: "not-connected_disconnected",
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_BUSY_LINE]: {
        id: "34c6823d-a6a5-5b0b-931f-f01f692ae6b5" as Uuid,
        displayName: "Not Connected Busy Line",
        flatDisposition: "not-connected_busy-line",
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_SWITCHED_OFF]: {
        id: "e60c2b81-cd9d-5efb-91a4-5a777d09800c" as Uuid,
        displayName: "Not Connected Switched Off",
        flatDisposition: "not-connected_switched-off",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_BUDGET_ISSUES]: {
        id: "c826fdeb-1ceb-5633-9e77-a4bb6b157fee" as Uuid,
        displayName: "Connected Lost Budget issues",
        flatDisposition: "connected_lost_budget-issues",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_OTHER_BRAND]: {
        id: "bb44fd3e-d5a4-5569-83dc-6695d0e01649" as Uuid,
        displayName: "Connected Lost Other brand",
        flatDisposition: "connected_lost_other-brand",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_JUST_EXPLORING]: {
        id: "358871f1-04eb-5a64-99d5-2414e60e4034" as Uuid,
        displayName: "Connected Lost Just exploring",
        flatDisposition: "connected_lost_just-exploring",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_OTHERS]: {
        id: "18c55460-6284-52c5-b092-25d3c18d3aa5" as Uuid,
        displayName: "Connected Lost Others",
        flatDisposition: "connected_lost_others",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_HIGH_INTENT_FOLLOW_UP]: {
        id: "c6bca430-e442-51cf-b5e6-ee971c4fbe0c" as Uuid,
        displayName: "Connected High Intent Follow-up",
        flatDisposition: "connected_high-intent_follow-up",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_HIGH_INTENT_ACTION_INITIATED]: {
        id: "d813df01-96c7-5a7c-a516-46ac6253b9f0" as Uuid,
        displayName: "Connected High Intent Action initiated",
        flatDisposition: "connected_high-intent_action-initiated",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_FUTURE_INTENT]: {
        id: "70159d2d-c077-5edb-8c0a-b2e5c89fc45f" as Uuid,
        displayName: "Connected Future Intent",
        flatDisposition: "connected_future-intent",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_TEST_ENTRY]: {
        id: "2b235dd6-3a8a-5323-a12d-10d56de0219f" as Uuid,
        displayName: "Connected Invalid Test entry",
        flatDisposition: "connected_invalid_test-entry",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_SPAM]: {
        id: "66369e2d-2e64-5bd8-b488-3658e9a4fad9" as Uuid,
        displayName: "Connected Invalid Spam",
        flatDisposition: "connected_invalid_spam",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_FILLED_BY_MISTAKE]: {
        id: "27378d19-66eb-51dc-a8bd-720cdec0c88c" as Uuid,
        displayName: "Connected Invalid Filled by mistake",
        flatDisposition: "connected_invalid_filled-by-mistake",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_DID_NOT_FILLED]: {
        id: "0601d8a2-ff17-5264-b12d-5cb2d1f405d7" as Uuid,
        displayName: "Connected Invalid Did not filled",
        flatDisposition: "connected_invalid_did-not-filled",
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_OTHERS]: {
        id: "cb310a1c-599e-5eee-9b66-0c96fb6b063c" as Uuid,
        displayName: "Connected Invalid Others",
        flatDisposition: "connected_invalid_others",
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_CALL_BACK_LATER]: {
        id: "cc61c6e3-95ae-52be-9cf2-941318eff998" as Uuid,
        displayName: "Interested Call Back Later",
        flatDisposition: "interested_call-back-later",
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_FUTURE_INTENT]: {
        id: "70cf0fdd-19b2-5782-a656-f8aba0977c38" as Uuid,
        displayName: "Interested Future Intent",
        flatDisposition: "interested_future-intent",
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_HIGH_INTEREST_FOLLOW_UP]: {
        id: "76891891-53ea-5da2-b241-9108146a1cd8" as Uuid,
        displayName: "Interested High Interest Follow Up",
        flatDisposition: "interested_high-interest_follow-up",
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_HIGH_INTEREST_ACTION_INITIATED]: {
        id: "19da3f20-684d-58ac-9941-3793398c4c51" as Uuid,
        displayName: "Interested High Interest Action Initiated",
        flatDisposition: "interested_high-interest_action-initiated",
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_PRICE_ISSUES]: {
        id: "795466c8-ff0e-58f5-ba5d-b744c8af45d2" as Uuid,
        displayName: "Not interested Price issues",
        flatDisposition: "not-interested_price-issues",
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_COMPETETION]: {
        id: "79ef2c80-0894-528f-876a-57f0e99b3e5b" as Uuid,
        displayName: "Not interested Competetion",
        flatDisposition: "not-interested_competetion",
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_NOT_SATISFIED]: {
        id: "3b087d45-c09f-5571-8054-8403c96b4da6" as Uuid,
        displayName: "Not interested Not satisfied",
        flatDisposition: "not-interested_not-satisfied",
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_JUST_EXPLORING]: {
        id: "1039d43a-1cec-5403-90a5-16f4d2993931" as Uuid,
        displayName: "Not interested Just exploring",
        flatDisposition: "not-interested_just-exploring",
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_NO_SHOW]: {
        id: "67a7d061-0f6a-556c-9de1-a638ebeca8e2" as Uuid,
        displayName: "Not interested No-show",
        flatDisposition: "not-interested_no-show",
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_OTHERS]: {
        id: "745e3506-c4cc-5b69-9579-6c754fd513a0" as Uuid,
        displayName: "Not interested Others",
        flatDisposition: "not-interested_others",
    },
};

/** Journey/call disposition dropdown — same as Dulux `getEventContainerDispositions` / Bobcard (id + flatDisposition slug). */
export const getEmotoradEventContainerDispositions = () =>
    Object.values(emotoradEventContainerDispositions).map((d) => ({
        id: d.id,
        displayName: d.flatDisposition,
    }));

/** Enquiry digital lead status (New / Duplicate / Return). */
export const emotoradEnquiryDigitalLeadStatuses: Record<
    EmotoradEnquiryDigitalLeadStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [EmotoradEnquiryDigitalLeadStatusEnum.NEW]: {
        id: EmotoradEnquiryDigitalLeadStatusEnum.NEW as Uuid,
        displayName: "New",
    },
    [EmotoradEnquiryDigitalLeadStatusEnum.DUPLICATE]: {
        id: EmotoradEnquiryDigitalLeadStatusEnum.DUPLICATE as Uuid,
        displayName: "Duplicate",
    },
    [EmotoradEnquiryDigitalLeadStatusEnum.RETURN]: {
        id: EmotoradEnquiryDigitalLeadStatusEnum.RETURN as Uuid,
        displayName: "Return",
    },
};

export const getEmotoradEnquiryDigitalLeadStatuses = () => Object.values(emotoradEnquiryDigitalLeadStatuses);

/** Single template disposition for lead events (ingest-only; status lives on Digital Lead Status column). */
export const emotoradEnquiryDispositions: Record<
    EmotoradEnquiryDispositionEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [EmotoradEnquiryDispositionEnum.OPEN]: {
        id: EmotoradEnquiryDispositionEnum.OPEN as Uuid,
        displayName: "Open",
    },
};

export const getEmotoradEnquiryDispositions = () => Object.values(emotoradEnquiryDispositions);

/** Lifecycle overview status IDs for Emotorad journeys. */
export enum EmotoradEventContainerStatusEnum {
    LIVE = "df7ee7ef-1dd7-5c14-a3f9-e1de013fb032",
    CONVERTED = "e82c82b5-aea1-49ad-947c-d9801479e02a",
    CHURNED = "e3e4025a-a9af-5062-a102-dd57e71dbf38",
    DUPLICATE = "c6aa587b-fc68-49c0-94f9-302528876b51",
    ARCHIVE = "a8dd5fee-ea91-54f3-bf33-bd967aa9b7d5",
}

export type EmotoradEventContainerStatus = {
    id: Uuid;
    displayName: string;
};

export const emotoradEventContainerStatuses: Record<EmotoradEventContainerStatusEnum, EmotoradEventContainerStatus> = {
    [EmotoradEventContainerStatusEnum.LIVE]: {
        id: EmotoradEventContainerStatusEnum.LIVE as Uuid,
        displayName: "Live",
    },
    [EmotoradEventContainerStatusEnum.CONVERTED]: {
        id: EmotoradEventContainerStatusEnum.CONVERTED as Uuid,
        displayName: "Converted",
    },
    [EmotoradEventContainerStatusEnum.CHURNED]: {
        id: EmotoradEventContainerStatusEnum.CHURNED as Uuid,
        displayName: "Churned",
    },
    [EmotoradEventContainerStatusEnum.DUPLICATE]: {
        id: EmotoradEventContainerStatusEnum.DUPLICATE as Uuid,
        displayName: "Duplicate",
    },
    [EmotoradEventContainerStatusEnum.ARCHIVE]: {
        id: EmotoradEventContainerStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

export const getEmotoradEventContainerStatuses = (): Array<EmotoradEventContainerStatus> => Object.values(emotoradEventContainerStatuses);

/** Category — Online, CSV, Aggregator. */
export const emotoradCategories: Record<EmotoradCategoryEnum, {id: Uuid; displayName: string}> = {
    [EmotoradCategoryEnum.ONLINE]: {
        id: EmotoradCategoryEnum.ONLINE as Uuid,
        displayName: "Online",
    },
    [EmotoradCategoryEnum.CSV]: {
        id: EmotoradCategoryEnum.CSV as Uuid,
        displayName: "CSV",
    },
    [EmotoradCategoryEnum.AGGREGATOR]: {
        id: EmotoradCategoryEnum.AGGREGATOR as Uuid,
        displayName: "Aggregator",
    },
};

export const getEmotoradCategorySelectOptions = () => Object.values(emotoradCategories);

/** Expected riding frequency — lead, call, walk-in, test ride. */
export const emotoradExpectedRidingFrequencies: Record<EmotoradExpectedRidingFrequencyEnum, {id: Uuid; displayName: string}> = {
    [EmotoradExpectedRidingFrequencyEnum.DAILY]: {
        id: EmotoradExpectedRidingFrequencyEnum.DAILY as Uuid,
        displayName: "Daily",
    },
    [EmotoradExpectedRidingFrequencyEnum.ONCE_A_WEEK]: {
        id: EmotoradExpectedRidingFrequencyEnum.ONCE_A_WEEK as Uuid,
        displayName: "Once a week",
    },
    [EmotoradExpectedRidingFrequencyEnum.TWICE_A_WEEK]: {
        id: EmotoradExpectedRidingFrequencyEnum.TWICE_A_WEEK as Uuid,
        displayName: "Twice a week",
    },
};

export const getEmotoradExpectedRidingFrequencySelectOptions = () => Object.values(emotoradExpectedRidingFrequencies);

/** L1 slug for {@link EmotoradEventContainerDispositionEnum.NEW_LEAD} — system default, not user-selectable on log-call / walk-in / test-ride forms. */
export const EMOTORAD_EVENT_CONTAINER_DISPOSITION_NEW_LEAD_L1_SLUG = emotoradEventContainerDispositions[EmotoradEventContainerDispositionEnum.NEW_LEAD].flatDisposition;

/**
 * Per-leaf disposition rules (L1/L2/L3 product spec). Drives {@link EMOTORAD_DEFAULT_EVENT_CONTAINER_TRIGGER_CONFIG}
 * and documents behaviour; `emotoradDispositionConfig` encodes hide-New-Lead and suggested churn.
 */
export const EMOTORAD_EVENT_CONTAINER_DISPOSITION_RULES: Record<EmotoradEventContainerDispositionEnum, EmotoradEventContainerDispositionRule> = {
    [EmotoradEventContainerDispositionEnum.NEW_LEAD]: {
        implementationNote:
            "This disposition is assigned when a lead enters the system until a user updates disposition. " +
            "After any user disposition change, New Lead is not offered at L1.",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_INVALID_NUMBER_NUMBER_UNREACHABLE]: {
        implementationNote: "L3: Number unreachable.",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_DND_REGISTERED_NUMBER_UNREACHABLE]: {
        implementationNote: "L3: Number unreachable.",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_NO_ANSWER]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_DISCONNECTED]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_BUSY_LINE]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_CONNECTED_SWITCHED_OFF]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_BUDGET_ISSUES]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_OTHER_BRAND]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_JUST_EXPLORING]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_LOST_OTHERS]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_HIGH_INTENT_FOLLOW_UP]: {
        implementationNote: "User must schedule next call.",
        requiresScheduleNextCall: true,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_HIGH_INTENT_ACTION_INITIATED]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_FUTURE_INTENT]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_TEST_ENTRY]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_SPAM]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_FILLED_BY_MISTAKE]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_DID_NOT_FILLED]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.CONNECTED_INVALID_OTHERS]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_CALL_BACK_LATER]: {
        implementationNote: "User must schedule next call.",
        requiresScheduleNextCall: true,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_FUTURE_INTENT]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_HIGH_INTEREST_FOLLOW_UP]: {
        implementationNote: "User must schedule next call.",
        requiresScheduleNextCall: true,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.INTERESTED_HIGH_INTEREST_ACTION_INITIATED]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_PRICE_ISSUES]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_COMPETETION]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_NOT_SATISFIED]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_JUST_EXPLORING]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_NO_SHOW]: {
        implementationNote: "",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: false,
    },
    [EmotoradEventContainerDispositionEnum.NOT_INTERESTED_OTHERS]: {
        implementationNote: "User can enter free text (remarks).",
        requiresScheduleNextCall: false,
        requiresFreeTextRemarks: true,
    },
};

export function getEmotoradEventContainerDispositionIdsRequiringScheduleNextCall(): Array<Uuid> {
    const ids: Array<Uuid> = [];
    const enumNumericValues = Object.values(EmotoradEventContainerDispositionEnum).filter((v): v is EmotoradEventContainerDispositionEnum => typeof v === "number");
    for (const dispositionKey of enumNumericValues) {
        const rule = EMOTORAD_EVENT_CONTAINER_DISPOSITION_RULES[dispositionKey];
        if (rule.requiresScheduleNextCall === true) {
            ids.push(emotoradEventContainerDispositions[dispositionKey].id);
        }
    }
    return ids;
}
